import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaFornecedor } from './types';

export const INITIAL_STATE: ConsultaFornecedor = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaFornecedor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_FORNECEDOR_REQUEST: {
				break;
			}
			case Types.CONSULTA_FORNECEDOR_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_FORNECEDOR_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_FORNECEDOR_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
